/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import clsx from "clsx";
import UploadImage from "./Components/UploadImage";
import UploadImageDelete from "./Components/UploadImageDelete";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import keyboardObserver from "keyboard-height";
import ImagesConfig from "components/ImagesConfig";

import {
	getInfomationStoreDetailAction,
	uploadImageProfileAction,
	updateInfomationStoreAction
} from "store/actions/InfomationStorePageAction";
import { Grid, TextField, Button, MenuItem } from "@material-ui/core";
import { connect } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Images } from "config/images";
import { useHistory } from "react-router-dom";

const BUSINESS_TYPE = [
	{
		value: "INDIVIDUAL",
		label: "Cá nhân"
	},
	{
		value: "HOUSEHOLE_BUSINESS",
		label: "Hộ kinh doanh"
	},
	{
		value: "ENTERPRISE",
		label: "Doanh nghiệp"
	}
];

const InfomationStorePage = props => {
	const classes = useStyles();
	const {
		getInfomationStoreDetail,
		infomationStore,
		uploadImageProfile,
		updateInfomationStore
	} = props;

	const {
		handleSubmit,
		control,
		setValue,
		formState: { errors }
	} = useForm({
		defaultValues: {
			owner: "",
			phone: "",
			name: "",
			address: "",
			identifyCardNumber: "",
			taxCode: "",
			businessName: "",
			businessAddress: "",
			businessTaxCode: ""
		}
	});
	const history = useHistory();

	const isAndroid = /Android/.test(navigator.userAgent);

	const [imageShop, setImageShop] = useState(null);
	const [businessForm, setBusinessForm] = useState("");
	const [imageIdentityCardBefore, setImageIdentityCardBefore] =
		useState(null);
	const [imageIdentityCardAfter, setImageIdentityCardAfter] = useState(null);
	const [isShowKeyboard, setIsShowKeyboard] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);

	const heightKeyboard = keyboardObserver.getKeyboardHeight();

	keyboardObserver.on(newHeight => {
		if (newHeight > 0) {
			setIsShowKeyboard(true);
		} else {
			setIsShowKeyboard(false);
		}
	});

	const HEIGHT_BODY = `calc(100vh - ${
		190 + (isShowKeyboard ? (isAndroid ? 10 : heightKeyboard) : 0)
	}px)`;

	useEffect(() => {
		const image = infomationStore?.image;
		setImageShop(image ? image : null);
		const identifyCardImageAfter = infomationStore?.identifyCardImageAfter;
		setImageIdentityCardAfter(
			identifyCardImageAfter ? identifyCardImageAfter : null
		);
		const identifyCardImageBefore =
			infomationStore?.identifyCardImageBefore;
		setImageIdentityCardBefore(
			identifyCardImageBefore ? identifyCardImageBefore : null
		);
		setBusinessForm(infomationStore?.businessForm || "INDIVIDUAL");
		setValue("owner", infomationStore.owner ? infomationStore.owner : "");
		setValue(
			"businessName",
			infomationStore.businessName ? infomationStore.businessName : ""
		);
		setValue(
			"businessAddress",
			infomationStore.businessAddress
				? infomationStore.businessAddress
				: ""
		);
		setValue(
			"businessTaxCode",
			infomationStore.businessTaxCode
				? infomationStore.businessTaxCode
				: ""
		);
		setValue("phone", infomationStore.phone ? infomationStore.phone : "");
		setValue("name", infomationStore.name ? infomationStore.name : "");
		setValue(
			"address",
			infomationStore.address ? infomationStore.address : ""
		);
		setValue(
			"identifyCardNumber",
			infomationStore.identifyCardNumber
				? infomationStore.identifyCardNumber
				: ""
		);
		setValue(
			"taxCode",
			infomationStore.taxCode ? infomationStore.taxCode : ""
		);
	}, [infomationStore]);

	useEffect(() => {
		getInfomationStoreDetail();
	}, []);

	const onSubmit = data => {
		setIsDisabled(true);
		if (!isShowKeyboard) {
			const {
				address,
				identifyCardNumber,
				owner,
				phone,
				name,
				taxCode,
				businessName,
				businessAddress,
				businessTaxCode
			} = data;

			const onSuccess = () => {
				setIsDisabled(false);
				history.push("/user");
			};
			const onFail = () => {
				setIsDisabled(false);
			};
			const dataUpdate = {
				address: address,
				identifyCardNumber: identifyCardNumber,
				owner: owner,
				phone: phone,
				name: name,
				taxCode: taxCode,
				image: imageShop,
				identifyCardImageAfter: imageIdentityCardAfter,
				identifyCardImageBefore: imageIdentityCardBefore,
				businessForm: businessForm,
				businessName: businessName,
				businessAddress: businessAddress,
				businessTaxCode: businessTaxCode
			};
			const dataSubmit = {
				dataUpdate,
				onSuccess,
				onFail
			};
			updateInfomationStore(dataSubmit);
		}
	};

	const handleUploadImage = (e, type) => {
		const onSuccess = link => {
			switch (type) {
				case "IMAGE_SHOP":
					setImageShop(link);
					break;
				case "IDENTITY_CARD_BEFORE":
					setImageIdentityCardBefore(link);
					break;
				case "IDENTITY_CARD_AFTER":
					setImageIdentityCardAfter(link);
					break;
				default:
					break;
			}
		};
		let files = "";
		if (e?.target?.files && e?.target?.files.length > 0) {
			files = e?.target?.files[0];
		}
		const dataFile = {
			files: files,
			onSuccess
		};
		uploadImageProfile(dataFile);
		e.target.value = null;
	};

	const handleDeleteImage = type => {
		if (type === "IDENTITY_CARD_BEFORE") {
			setImageIdentityCardBefore(null);
		} else {
			setImageIdentityCardAfter(null);
		}
	};

	const handleBusinessForm = value => {
		setBusinessForm(value);
		setValue("businessName", undefined);
		setValue("businessAddress", undefined);
		setValue("businessTaxCode", undefined);
		setImageIdentityCardBefore(null);
		setImageIdentityCardAfter(null);
	};

	return (
		<React.Fragment>
			<Grid classes={{ root: classes.rootHeader }}>
				<Grid classes={{ root: classes.header }}>
					<Grid
						classes={{ root: classes.btnBack }}
						onClick={() => {
							history.goBack();
						}}
					>
						<ArrowBackIcon />
					</Grid>
					<Grid classes={{ root: classes.titleHeader }}>
						Thông tin cửa hàng
					</Grid>
				</Grid>
				<Grid classes={{ root: classes.customAvatar }}>
					<Grid classes={{ root: classes.avatar }}>
						<UploadImage
							handleUploadImage={handleUploadImage}
							type="IMAGE_SHOP"
						>
							<Grid classes={{ root: classes.btnCamera }}>
								<img
									src={Images.icCamera}
									alt={Images.icCamera}
								/>
							</Grid>
						</UploadImage>
						<ImagesConfig
							image={imageShop}
							width={90}
							height={90}
							imageDefault={Images.icAvatar}
						/>
					</Grid>
					<Grid classes={{ root: classes.textCamera }}>
						Ảnh chụp cửa hàng
					</Grid>
				</Grid>
			</Grid>
			<Grid
				style={{
					height: HEIGHT_BODY,
					overflowY: "scroll",
					overflowX: "hidden"
				}}
			>
				<Grid classes={{ root: classes.root }}>
					<form onSubmit={handleSubmit(onSubmit)}>
						<Grid style={{ padding: "0px 15px", marginTop: 20 }}>
							<Grid classes={{ root: classes.storeOwner }}>
								<img src={Images.icBgUser} alt={"icBgUser"} />
								Thông tin chủ cửa hàng <span>(*)</span>
							</Grid>
						</Grid>
						<Grid classes={{ root: classes.rootForm }}>
							<Grid classes={{ root: classes.title }}>
								Họ và tên
							</Grid>
							<Controller
								control={control}
								name="owner"
								rules={{
									required: "Vui lòng nhập họ và tên"
								}}
								render={({ field }) => (
									<TextField
										{...field}
										placeholder="Họ và tên"
										className={clsx(
											classes.customInput,
											errors?.owner
												? classes.inputError
												: ""
										)}
										onKeyPress={event => {
											if (event.key === "Enter") {
												event.target.blur();
											}
										}}
									/>
								)}
							/>
							{errors?.owner && (
								<Grid classes={{ root: classes.textError }}>
									{errors.owner.message}
								</Grid>
							)}
							<Grid classes={{ root: classes.title }}>
								Số điện thoại
							</Grid>
							<Controller
								control={control}
								name="phone"
								rules={{
									required: "Vui lòng nhập số điện thoại"
								}}
								render={({ field }) => (
									<TextField
										{...field}
										type="text"
										placeholder="Số điện thoại"
										className={clsx(
											classes.customInput,
											errors?.phone
												? classes.inputError
												: ""
										)}
										onKeyPress={event => {
											if (event.key === "Enter") {
												event.target.blur();
											}
										}}
									/>
								)}
							/>
							{errors?.phone && (
								<Grid classes={{ root: classes.textError }}>
									{errors.phone.message}
								</Grid>
							)}
							<Grid classes={{ root: classes.title }}>
								Tên cửa hàng
							</Grid>
							<Controller
								control={control}
								name="name"
								rules={{
									required: "Vui lòng nhập tên cửa hàng"
								}}
								render={({ field }) => (
									<TextField
										{...field}
										type="text"
										placeholder="Tên cửa hàng"
										className={clsx(
											classes.customInput,
											errors?.name
												? classes.inputError
												: ""
										)}
										onKeyPress={event => {
											if (event.key === "Enter") {
												event.target.blur();
											}
										}}
									/>
								)}
							/>
							{errors?.name && (
								<Grid classes={{ root: classes.textError }}>
									{errors.name.message}
								</Grid>
							)}
							<Grid classes={{ root: classes.title }}>
								Địa chỉ
							</Grid>
							<Controller
								control={control}
								name="address"
								rules={{
									required: "Vui lòng nhập số điện thoại"
								}}
								render={({ field }) => (
									<TextField
										{...field}
										type="text"
										placeholder="Địa chỉ"
										className={clsx(
											classes.customInput,
											errors?.address
												? classes.inputError
												: ""
										)}
										onKeyPress={event => {
											if (event.key === "Enter") {
												event.target.blur();
											}
										}}
									/>
								)}
							/>
							{errors?.address && (
								<Grid classes={{ root: classes.textError }}>
									{errors.address.message}
								</Grid>
							)}

							<Grid classes={{ root: classes.title }}>
								Số CMND/CCCD
							</Grid>
							<Controller
								control={control}
								name="identifyCardNumber"
								rules={{
									required: "Vui lòng nhập số CMND/CCCD"
								}}
								render={({ field }) => (
									<TextField
										{...field}
										type="text"
										placeholder="Số CMND/CCCD"
										className={clsx(
											classes.customInput,
											errors?.identifyCardNumber
												? classes.inputError
												: ""
										)}
										onKeyPress={event => {
											if (event.key === "Enter") {
												event.target.blur();
											}
										}}
									/>
								)}
							/>
							{errors?.identifyCardNumber && (
								<Grid classes={{ root: classes.textError }}>
									{errors.identifyCardNumber.message}
								</Grid>
							)}
							<Grid classes={{ root: classes.storeOwner }}>
								<img src={Images.icBgNote} alt={"icBgNote"} />
								Thông tin xuất hóa đơn
							</Grid>
							<Grid
								classes={{ root: classes.title }}
								style={{ marginTop: 15 }}
							>
								Hình thức kinh doanh
							</Grid>
							<TextField
								select
								value={businessForm}
								className={classes.customInput}
								onChange={event => {
									handleBusinessForm(event.target.value);
								}}
							>
								{BUSINESS_TYPE.map(option => (
									<MenuItem
										key={option.value}
										value={option.value}
									>
										{option.label}
									</MenuItem>
								))}
							</TextField>
							<Grid classes={{ root: classes.title }}>
								{businessForm === "INDIVIDUAL"
									? "Họ và tên"
									: businessForm === "HOUSEHOLE_BUSINESS"
									? "Tên hộ kinh doanh"
									: "Tên công ty/doanh nghiệp"}
							</Grid>
							<Controller
								control={control}
								name="businessName"
								render={({ field }) => (
									<TextField
										{...field}
										placeholder={
											businessForm === "INDIVIDUAL"
												? "Họ và tên"
												: businessForm ===
												  "HOUSEHOLE_BUSINESS"
												? "Tên hộ kinh doanh"
												: "Tên công ty/doanh nghiệp"
										}
										className={classes.customInput}
										onKeyPress={event => {
											if (event.key === "Enter") {
												event.target.blur();
											}
										}}
									/>
								)}
							/>
							<Grid classes={{ root: classes.title }}>
								Địa chỉ
							</Grid>
							<Controller
								control={control}
								name="businessAddress"
								render={({ field }) => (
									<TextField
										{...field}
										placeholder="Địa chỉ"
										className={classes.customInput}
										onKeyPress={event => {
											if (event.key === "Enter") {
												event.target.blur();
											}
										}}
									/>
								)}
							/>
							<Grid classes={{ root: classes.title }}>
								{businessForm === "INDIVIDUAL"
									? "Số CMND/CCCD"
									: "Mã số thuế"}
							</Grid>
							<Controller
								control={control}
								name="businessTaxCode"
								render={({ field }) => (
									<TextField
										{...field}
										placeholder={
											businessForm === "INDIVIDUAL"
												? "Số CMND/CCCD"
												: "Mã số thuế"
										}
										className={classes.customInput}
										onKeyPress={event => {
											if (event.key === "Enter") {
												event.target.blur();
											}
										}}
									/>
								)}
							/>
							{businessForm !== "INDIVIDUAL" && (
								<Grid
									classes={{ root: classes.title }}
									style={{ marginBottom: 10 }}
								>
									Giấy phép kinh doanh
								</Grid>
							)}
							<Grid
								container
								spacing={1}
								style={{ marginBottom: 10 }}
							>
								<Grid item xs={6}>
									<UploadImageDelete
										handleUploadImage={handleUploadImage}
										type="IDENTITY_CARD_BEFORE"
										handleDeleteImage={handleDeleteImage}
										image={imageIdentityCardBefore}
										businessForm={"INDIVIDUAL"}
									>
										{businessForm === "INDIVIDUAL"
											? "Mặt trước"
											: "Chụp ảnh"}
									</UploadImageDelete>
								</Grid>
								<Grid item xs={6}>
									<UploadImageDelete
										handleUploadImage={handleUploadImage}
										type="IDENTITY_CARD_AFTER"
										handleDeleteImage={handleDeleteImage}
										image={imageIdentityCardAfter}
										businessForm={businessForm}
									>
										{businessForm === "INDIVIDUAL"
											? "Mặt sau"
											: "Thêm ảnh chụp"}
									</UploadImageDelete>
								</Grid>
							</Grid>
							<Grid classes={{ root: classes.bodyBtnSubmit }}>
								<Button
									type="submit"
									disabled={isDisabled}
									classes={{
										root: classes.btnSubmit,
										disabled: classes.btnSubmitDisabled
									}}
								>
									Cập nhật thông tin
								</Button>
							</Grid>
						</Grid>
					</form>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

const mapStateToProps = state => {
	return {
		infomationStore: state.infomationStorePageReducer.infomationStore
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getInfomationStoreDetail: () => {
			dispatch(getInfomationStoreDetailAction());
		},
		uploadImageProfile: file => {
			dispatch(uploadImageProfileAction(file));
		},
		updateInfomationStore: dataUpdate => {
			dispatch(updateInfomationStoreAction(dataUpdate));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(InfomationStorePage);
